import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var listaunidadest=[];
var tipoveiculo1=[]; 
export default function  ParadaMap (props) {
    const [statelista, setalista]=React.useState(['']);
const [statetipoveiculo,setatipoveiculo]=React.useState([{
    id:'', label:''
}]);
//const[codtipo,setacodtipo]=React.useState('');
    React.useEffect (()=>{
        if(props.codtipoveiculo!=''){
        firebase.firestore().collection("veiculos").where('codtipoveiculo','==',props.codtipoveiculo)
        .where('codunidadetransporte','==',props.codunidadetransporte).where('status','==',true)
        .get()
        .then(function(querySnapshot) {
            listaunidadest=[];
            querySnapshot.forEach(function(doc) {
                listaunidadest.push({id: doc.id, label: doc.data().modelo + ' - '+ doc.data().placa, livre:true,

            });
            })

            console.log("listass tipos de veiculos: ", listaunidadest);
            
            var listdef=[];
                       for (let ndex = 0; ndex < listaunidadest.length; ndex++) {
                                var db1 = firebase.firestore();
                    var userref = db1.collection("veiculos").doc(listaunidadest[ndex].id).collection("reservas");
                    userref.get().then(function(querySnapshot) {
                       
                        
                        querySnapshot.forEach(function(doc) {
                            console.log(doc.data().datainicio);
                            if((doc.data().datainicio!=undefined)&&(doc.data().datafim!=undefined)){
                                console.log(props.saida);
                                console.log(firebase.firestore.Timestamp.fromDate(props.retorno));
                                console.log(doc.data().datainicio);
                                console.log(doc.data().datafim);
                                console.log(doc.data().datafim);

                                
                                if(((props.saida>=doc.data().datainicio)&&(props.saida<doc.data().datafim))||
                                ((props.saida<=doc.data().datainicio)&&(firebase.firestore.Timestamp.fromDate(props.retorno)>doc.data().datainicio))){
                                    listaunidadest[ndex].livre=false;
                                }

                        }
                            
                        })
                        listdef=[];
                        for (let x = 0; x < listaunidadest.length; x++) {
            
                            if(listaunidadest[x].livre==true){
                                listdef.push(listaunidadest[x]);
                            }
                            setalista(listdef);
                        }
                        


                        
                                      
                   
            }).catch(function(error) {
                console.log("erro carregar as unidades de tipos veiculos: ", error);
                alert('Não foi Possível carregar Motoristas.');
            });
        }


//setalista(listaunidadest);
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de tipos veiculos: ", error);
            alert('Não foi Possível carregar os veículos.');
        });
    }
        
           
        
            },[props])


           
   

    const handleuniade=(event,value)=>(
        setatipoveiculo([value]),
        console.log("targekkkkkkkkkkkkkkkkkkt ", value),
        props.setaveiculo(value),
        console.log("targekkkkkkkkkkkkkkkkkkt ", value)
        //setatipoveiculo(value),
       
    )
    console.log("target4 ", props.props)
    return(
        <Autocomplete onChange={handleuniade}
                    

                    id="combounidadetchef"
                    options={statelista}
                    disabled={props.disabled}
                    getOptionLabel={(option) =>(typeof option === 'string' ? option :option.label)}
                   // value={tipoveiculo1[0]}
                   //(option) => (typeof option === 'string' ? option : option.description)
                   value={statetipoveiculo[0]}
                   //defaultValue={tipoveiculo1[0]}
                   getOptionSelected={(option,temp) => option.id==temp.id}
                    renderInput={(params) => <TextField {...params}  required={props.requer}  label="Veículo" variant="outlined" />}
                />
                
)
}